<template>
  <div>
    <b-table
      show-empty
      :fields="tableDataFields"
      :items="tableData"
      :busy="isBusy"
      thead-class="hidden-header"
      class="bg-white"
      size="small"
    >
      <template v-slot:cell(prjMilestone)="tableData">
        <span class="table-text">{{ tableData.item.milestonesTypeText }}</span>
        <span class="ml-2 table-text-weight"
          >{{ tableData.item.beginTime }}~{{ tableData.item.endTime }}</span
        >
        <br />
        <span class="font-12 text_description">{{
          tableData.item.milestonesDesc
        }}</span>
        <div class="mt-1">
          <p class="progress-p">
            Progress with: {{ tableData.item.scheduleValue }}%
          </p>
          <b-progress
            :variant="
              tableData.item.scheduleStatus === 'E'
                ? 'success'
                : tableData.item.scheduleStatus === 'N'
                ? 'secondary'
                : tableData.item.scheduleStatus === 'P'
                ? 'info'
                : ''
            "
            height="0.3rem"
            :value="tableData.item.scheduleValue"
            :max="max"
            animated
          ></b-progress>
        </div>
        <div class="d-flex justify-content-between mt-1">
          <div>
            <b-badge
              class="mb-1"
              :variant="
                tableData.item.scheduleStatus === 'E'
                  ? 'success'
                  : tableData.item.scheduleStatus === 'N'
                  ? 'secondary'
                  : tableData.item.scheduleStatus === 'P'
                  ? 'info'
                  : ''
              "
            >
              {{
                tableData.item.scheduleStatus === "E"
                  ? $l("label_finished") || "已结束"
                  : tableData.item.scheduleStatus === "P"
                  ? $l("label_in_progress") || "进行中"
                  : tableData.item.scheduleStatus === "N"
                  ? $l("label_inactive") || "未开始"
                  : ""
              }}
            </b-badge>
          </div>
          <div>
            <a
              class="table-text"
              v-if="tableData.item.isChecked === 'N'"
              @click="confirm(tableData.item.scheduleCode, 'Y')"
              role="button"
            >
              <i class="el-icon-check" /><span class="ml-2">{{
                $l("btn_schedule_isCheckedOver") || "确认完成"
              }}</span>
            </a>
          </div>
        </div>
      </template>
      <template v-slot:empty="scope">
        <div align="center">
          <img src="/image/static/img/nodata.png" />
          <p class="text-secondary mt-2">
            {{ $l("INDEX.tips_no_data") || "暂无数据！" }}
          </p>
        </div>
      </template>
    </b-table>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    params: {
      default: null,
      type: Object,
    },
    disabled: {
      default: true,
      type: Boolean,
    },
    autoLoad: {
      default: false,
      type: Boolean,
    },
    height: {
      default: 272,
      type: Number,
    },
  },
  watch: {
    params: {
      handler() {
        if (this.autoLoad) {
          this.init();
        }
      },
      deep: true,
      immediate: true,
    },
  },
  data() {
    return {
      isBusy: false,
      max: 100,
      tableData: [],
      tableDataFields: [
        {
          key: "prjMilestone",
          label: "里程碑节点",
          tdClass: "align-middle",
        },
      ],
      page: {
        curPage: 1,
        pageSize: 10,
        total: 0,
      },
    };
  },
  methods: {
    load(params) {
      this.init(params);
    },
    init(params) {
      this.page.pageTotal = 0;
      this.page.curPage = 1;
      this.page.pageSize = 20;
      this.getData(params);
    },
    getData(params) {
      this.isBusy = true;
      this.$api
        .scheduleListApi({
          ...(params || this.params),
          ...this.page,
        })
        .then((res) => {
          this.isBusy = false;
          this.page.total = res.body.count;
          this.page.curPage = res.body.curPage;
          this.page.pageSize = res.body.pageSize;
          this.tableData = res.body.data;
        })
        .catch(() => {
          this.isBusy = false;
        });
    },
    confirm(val, val2) {
      this.$confirm(
        this.$l("tips_sure") || "是否确认？",
        this.$l("INDEX.tips_question_title") || "提示",
        {
          confirmButtonText: this.$l("INDEX.tips_confirm") || "确定",
          cancelButtonText: this.$l("INDEX.tips_cancel") || "取消",
          type: "warning",
        }
      ).then(() => {
        this.$api
          .scheduleConfirmApi({
            scheduleCode: val,
            isChecked: val2,
          })
          .then((res) => {
            this.$message({
              showClose: true,
              message: this.$l("tips_action_ok") || "操作成功！",
              type: "success",
            });
            this.getData();
          });
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.table-text {
  color: #6c757d;
  font-size: 14px;
}
.table-text-weight {
  font-weight: 400;
  font-size: 14px;
}
.font-12 {
  font-size: 12px;
}
.progress-p {
  font-size: 12px;
  margin-bottom: 0;
}
.text_description {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
  height: 40px;
  line-height: 20px;
  color: #6c757d;
}
</style>
